import { SyncMutationInput } from '../../../schema';
import { validate } from 'sha-el-design';

export const retailerValidatorObject = {
  firm: validate
    .Text()
    .required('Firm Name is required')
    .match(/^[a-zA-Z0-9]+[0-9A-Za-z ]+/, 'Enter a valid Firm Name'),

  proprietor: validate
    .Text()
    .required('Proprietor Name is required')
    .match(/^[a-zA-Z0-9]+[0-9A-Za-z ]+/, 'Enter a valid Proprietor Name'),

  address: validate
    .Text()
    .required('Address is required')
    .match(/^[a-zA-Z0-9]+[0-9A-Za-z, ]+/, 'Enter a valid address'),

  pincode: validate
    .Text()
    .required('Pincode is required')
    .match(/^\d{6}$/, 'Enter a valid pincode'),

  classField: validate
    .Text()
    .required('Class is required')
    .match(/^[ABCD]{1}$/, 'Enter a valid Class Field'),

  mobilenumber1: validate
    .Text()
    .required('Mobile Number is required')
    .match(/^[0-9]{10}$/, 'Enter a valid mobile number'),

  mobilenumber2: validate
    .Text()
    .match(/^[0-9]{10}$/, 'Enter a valid mobile number'),
};

export const workListQuery = `
  query allAssignWorkList(
    $isFinished: Boolean!,
    $caller: ID,
    $offset: Int!,
    $areas: [Int],
    $towns: [Int],
    $states: [Int]
  ){
    finishedFilterAssignWork(
      isFinished: $isFinished,
      caller: $caller,
      offset: $offset,
      limit: 20,
      areas: $areas,
      towns: $towns,
      states: $states
    ){
      id
      dateAssigned
      deadline
      workStatus
      totalRetailersCalled
      state{
        id
        name
      }
      towns{
        id
        name
        retailerCount
      }
      areas{
        id
        name
        retailerCount
      }
      caller {
        id
        employee {
          id
          name
        }
      }
    }
  }
`;

export const addWorkHistoryMutation = `
mutation WorkHistoryMutation($input: WorkHistoryMutationInput!) {
  createWorkHistory(input: $input) {
    id
    isActive
    errors {
      field
      messages
    }
  }
}
`;

// PERF-01: patch ONE queue entry instead of re-POSTing the whole calls array.
// Payload is constant-size per call rather than proportional to the queue, and
// the server does the read-modify-write under a row lock, so two tabs can no
// longer silently overwrite each other's outcomes.
export const updateWorkHistoryCallMutation = `
mutation UpdateWorkHistoryCall(
  $workHistory: ID!,
  $retailerId: Int!,
  $callStatus: String!,
  $mobileNumber: String,
  $incrementAttempts: Boolean
) {
  updateWorkHistoryCall(
    workHistory: $workHistory,
    retailerId: $retailerId,
    callStatus: $callStatus,
    mobileNumber: $mobileNumber,
    incrementAttempts: $incrementAttempts
  ) {
    id
    ok
    errors
  }
}
`;

export const activeWorkQuery = `
query ActiveWorkQuery($caller: ID!) {
  allWorkHistory(work_Caller: $caller, onHold: false, isActive: true) {
    edges {
      node {
        id
        work {
          id
          deadline
          dateAssigned
          workStatus
          supervisor {
            employee {
              name
            }
          }
        }
        startDateTime
        totalCallsMade
        calls {
          retailer {
            id
            firm
            mobilenumber1
            mobilenumber2
            address
            classField
            numberInDnd
            proprietor
            pincode
            townid {
              name
              districtid {
                name
                stateid {
                  name
                }
              }
            }
          }
          mobileNumber
          callStatus
          attempts
        }
        area {
          id
          townid {
            id
            districtid {
              stateid {
                id
              }
            }
          }
        }
        town {
          id
          districtid {
            stateid {
              id
            }
          }
        }
      }
    }
  }
}
`;

export const mutation = `mutation syncWork($input: SyncMutationInput!) {
  createSync(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}`;

export const retForApprovalMutation = `mutation retForApproval($input: RetailerForApprovalMutationInput!) {
  createRetailerForApproval(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}`;
